import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-modal" }
const _hoisted_2 = { class: "info-modal-wrapper" }
const _hoisted_3 = { class: "info-content" }
const _hoisted_4 = { class: "info-content-action" }
const _hoisted_5 = { class: "info-content-action" }
const _hoisted_6 = { class: "info-content-action" }
const _hoisted_7 = { class: "info-content-action" }

import { computed } from 'vue'
import CloseIconSVG from '../components/svgs/CloseIconSVG.vue'
import ActionLeftRightSVG from './svgs/ActionLeftRightSVG.vue';
import ActionUpDownSVG from './svgs/ActionUpDownSVG.vue';
import ActionTapSVG from './svgs/ActionTapSVG.vue';
import useStore from '../store/useStore'
import { data } from "@/data/dataHelper";

export default /*#__PURE__*/_defineComponent({
  __name: 'InfoModal',
  setup(__props) {

const store = useStore()
const languageUtilities = computed(() => {
  return data.translationsByLanguage(store.language);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_unref(languageUtilities).navigationPopup.titleText.toUpperCase()), 1),
      _createVNode(CloseIconSVG, {
        class: "close-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ActionLeftRightSVG),
          _createElementVNode("p", null, _toDisplayString(_unref(languageUtilities).navigationPopup.instruction1) + ".", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ActionTapSVG),
          _createElementVNode("p", null, _toDisplayString(_unref(languageUtilities).navigationPopup.instruction2) + ".", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ActionLeftRightSVG),
          _createElementVNode("p", null, _toDisplayString(_unref(languageUtilities).navigationPopup.instruction3) + ".", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(ActionUpDownSVG),
          _createElementVNode("p", null, _toDisplayString(_unref(languageUtilities).navigationPopup.instruction4) + ".", 1)
        ])
      ])
    ])
  ]))
}
}

})